/**
 * CODE_COMMENTS_31
 */
export const OUTBOUND_EMPTY_KEG_SHIPMENT_FULL_DETAILS_LABEL_REFERENCE_NUM = 'Reference #'
